import { CustomTypography } from 'app/shared/components/generic-ui/Typography/Typography';
import React, { useCallback, useState } from 'react';
import { INote, Routes } from 'types';
import { useStyles } from './Note.styles';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { translations } from 'app/locales/i18n';
import { useTranslation } from 'react-i18next';
import AcknowledgedIconWithNotes from 'assets/file-text.svg?react';
import { firebaseAnalytics } from 'app/shared/analytics';
import { formatTimeWithDateIfNotToday } from 'app/shared/utils/formatTimeWithDate';

interface INoteProps {
  note: INote;
  index: number;
}

const offset = 1;

export const Note = ({ note, index }: INoteProps) => {
  const { classes } = useStyles();
  const [isExpand, setIsExpand] = useState(false);
  const { t } = useTranslation();

  const handleComponentClick = useCallback(() => {
    firebaseAnalytics.logPressEvent(
      Routes.SinglePourEvent,
      'Batch event card acknowledgement spoiler',
    );

    setIsExpand(prevState => !prevState);
  }, []);

  return (
    <>
      <div className={classes.headerClickable} onClick={handleComponentClick}>
        <div className={classes.text}>
          <div className={classes.title}>
            <AcknowledgedIconWithNotes />

            <div className={classes.paddingContainer}>
              <CustomTypography variant="bodySmall" bold color="mbsBlue">
                {`${t(translations.batchEventCard.note)} #${index + offset}`}
              </CustomTypography>
            </div>
          </div>

          <CustomTypography variant="caption2" bold color="greyscale2">
            {`${t(translations.batchEventCard.by)} ${note.firstName || '-'} ${
              note.lastName || ''
            } ${t(
              translations.batchEventCard.at,
            )} ${formatTimeWithDateIfNotToday(note.createdOnUtc)}`}
          </CustomTypography>
        </div>

        <div className={classes.arrowContainer}>
          {isExpand ? (
            <ExpandLessIcon className={classes.expandIcon} />
          ) : (
            <ExpandMoreIcon className={classes.expandIcon} />
          )}
        </div>
      </div>
      {isExpand && (
        <div className={classes.noteContainer}>
          <CustomTypography variant="bodyRegular" color="accentDark">
            {note.noteText}
          </CustomTypography>
        </div>
      )}
    </>
  );
};
